// hooks/useWhatsappActivityListData.ts
import { getBimServiced } from '@api/services/analytics.service';
import useDataQuery from '@hooks/use-data-query';
import { useMemo } from 'react';

const useBimActivityListData = () => {
    const query = useDataQuery(['bim-activity'], () => getBimServiced());

    const data = useMemo(() => query.data || [], [query.data]);

    return {
        data,
        isLoading: query.isLoading,
    };
};

export default useBimActivityListData;
